/**
 * O player do Vimeo (spec r4/12). Um iframe com a URL de embed que o backend montou
 * (`player.vimeo.com/video/<id>?h=<hash>`) — a mesma peca no admin (preview) e no aluno.
 *
 * Video privado da conta do cliente so toca aqui se estiver "Nao listado" ou com o
 * dominio do MedHunter liberado no Vimeo; e configuracao da conta, nao do sistema.
 */
interface Props {
  embedUrl: string
  title: string
}

export default function VimeoEmbed({ embedUrl, title }: Props) {
  return (
    <div className="aspect-video w-full overflow-hidden rounded-lg bg-black">
      <iframe
        src={embedUrl}
        title={title}
        className="h-full w-full"
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
      />
    </div>
  )
}
